import { observer } from "mobx-react-lite";

import { SplitView } from "../ui/SplitView";
import { SetlistDetail } from "./SetlistDetail";
import { SetlistList } from "./SetlistList";

/** All setlists, next to the one that's picked. */
export const SetlistsScreen = observer(function SetlistsScreen({ setlistId }: { setlistId?: string }) {
    const detail = setlistId && <SetlistDetail key={setlistId} setlistId={setlistId} />;

    return <SplitView listLabel="Setlists" list={<SetlistList selectedId={setlistId} />} detail={detail} />;
});
